import { render, staticRenderFns } from "./grantStipsCards.vue?vue&type=template&id=89aa5572&scoped=true&"
import script from "./grantStipsCards.vue?vue&type=script&lang=js&"
export * from "./grantStipsCards.vue?vue&type=script&lang=js&"
import style0 from "./grantStipsCards.vue?vue&type=style&index=0&id=89aa5572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89aa5572",
  null
  
)

export default component.exports